// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const LoadingIcon = /* @__PURE__ */ createIcon(
  'loading',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M21 11a1 1 0 0 1 1 1 10 10 0 1 1-6.91-9.51 1 1 0 1 1-.618 1.902 8.001 8.001 0 0 0-8.945 12.31A8.001 8.001 0 0 0 20 12a1 1 0 0 1 1-1',
      },
    ],
  ]
);
